export class PCache {
  public data: any[];
  public expiration: number;
  public id: string;

  constructor(id = null, data = null, expiration = null) {
    this.id = id;
    this.data = data;
    this.expiration = expiration ? expiration : Date.now() + 1000000000000;
  }
}
